<template>
  <div>
    <div class="card p-3 mb-3">
      <b-row>
        <b-col>
          <fcc-table
            striped
            hover
            pdf
            xls
            csv
            responsive
            search
            pagination
            field-visibility
            :titlePage="titlePage"
            :titlePDF="titlePage"
            :fields="fields"
            :items="items"
            :porPage="itemPorPage"
            :key="keyTable"
            @row-selected="selecionaItems"
          />
        </b-col>
      </b-row>

      <b-row align-h="end">
        <b-col class="mb-3 text-right">
          <fcc-button :disabled="dadosSelecionados.length <= 0" @click="importar"
            >Importar</fcc-button
          >
        </b-col>
      </b-row>
    </div>

    <fcc-logs-importacao
      :base-url-publicacao="baseUrlPublicacao"
      :idoutfase="idoutfase"
      :controle-page="controlePage"
      :tp-importacao="tpImportacao"
      :logs="logs"
      @excluir="excluirImportacaoAlocacao"
    />
  </div>
</template>

<script>
import axios from 'axios'
import FccLogsImportacao from './fccLogsImportacao.vue'
import fccGravarLog from './fccGravarLog.vue'

export default {
  mixins: [fccGravarLog],
  props: {
    baseUrlPublicacao: String,
    idoutfase: Number,
    controlePage: Object,
    tpImportacao: Number
  },
  components: { FccLogsImportacao },
  data() {
    return {
      titlePage: 'Importação de Candidatos - Sub Judice',
      items: [],
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'idpublicacao', label: 'Publicação', sortable: true },
        { key: 'idoutfase', label: 'Outras Fases', sortable: true },
        { key: 'codcargo', label: 'Código Cargo', sortable: true },
        { key: 'numpedido', label: 'N° Pedido', sortable: true },
        { key: 'ninscricao', label: 'N° Inscrição', sortable: true },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'importado', label: 'Importado', sortable: true }
      ],
      itemPorPage: 10,
      keyTable: 0,
      dadosSelecionados: [],
      logs: []
    }
  },
  created() {
    this.obterCandidatosSubJudice()
    this.listarLogs()
  },
  methods: {
    selecionaItems(value) {
      this.dadosSelecionados = value
    },
    obterCandidatosSubJudice() {
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterCandidatosSubJudice',
          {
            idPublicacao: this.controlePage.idpublicacao,
            idOutraFase: this.idoutfase
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.items = data
        })
        .catch(this.setErrorSystem)
    },
    importar() {
      const body = this.dadosSelecionados.map((item) => ({
        idPublicacao: this.controlePage.idpublicacao,
        idOutraFase: this.idoutfase,
        tpImportacaoOutrasFases: this.tpImportacao,
        numPedido: +item.numpedido,
        cd_Funcionario: this.dadosUserSession.usuCdFuncionario
      }))

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ImportarCandidatosSubJudice',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast('Importado com sucesso.', 'success')
          this.keyTable = this.keyTable + 1
          this.gravarLogImportacaoCandidatosOutrasFases()
          this.obterCandidatosSubJudice()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarLogs() {
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterLogsImportacaoSubJudice',
          {
            id_Publicacao: this.controlePage.idpublicacao,
            id_Outrafase: this.idoutfase
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.logs = data
        })
        .catch(this.setErrorSystem)
    },
    excluirImportacaoAlocacao() {
      const body = {
        id_Publicacao: this.controlePage.idpublicacao,
        id_Outrafase: this.idoutfase,
        cd_Funcionario: this.dadosUserSession.usuCdFuncionario
      }

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'publicacaoOutrasFases/ExcluirCandidatosImportadosSubJudice',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.excluido, 'success')
          this.obterCandidatosSubJudice()
          this.listarLogs()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
</script>